import type { ReactNode } from "react";

import { ADS_MANAGER_CONTENT_SHELL_CLASS } from "../constants/layout";

type AdsManagerContentProps = {
  children: ReactNode;
  className?: string;
};

export function AdsManagerContent({
  children,
  className = "",
}: AdsManagerContentProps) {
  return (
    <div className={`${ADS_MANAGER_CONTENT_SHELL_CLASS} ${className}`.trim()}>
      {children}
    </div>
  );
}
